import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";

const page = usePage()
export const useFlashData = computed(() => page.props.flash as any)
